<template>
  <artisio-modal size="xl" :visible="modal.show" :title="assignItemsDisplayFieldFunction"
                 @ok="onSubmit" ok-title="Next" @hidden="onHidden" :disable-submit-btn="disableSubmitBtn"
                 :is-loading="loading" :content-in-form="false" scrollable :body-class="'p-2'">
    <template>
      <div class="reserve-items">
        <InventoryTable :exclude-header-actions="excludeHeaderActions" :show-assign-to-sale="false"
                        :exclude-search-fields="['sale_no', 'department', 'account_manager_uuid','department_uuid', 'date', 'collected_status', 'proposal_status', 'proposal_suggestion']"
                        :exclude-item-action-buttons="['edit', 'remove']"
                        :exclude-columns="['proposal_status', 'proposal_suggestion']"
                        @selectedItemsChange="onSelectedItemsChange"/>
      </div>
    </template>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal.vue";
  import {createNamespacedHelpers} from "vuex";
  import InventoryTable from "@/modules/inventory/InventoryTable.vue";
  import {
    ACTION_INVENTORY_ARCHIVE,
    ACTION_INVENTORY_BATCH_DELETE,
    ACTION_INVENTORY_CONT_AUCTION_BATCH_LOT_UP,
    ACTION_INVENTORY_CREATE_AND_DUPLICATE,
    ACTION_INVENTORY_GROUP_ITEMS,
    ACTION_INVENTORY_RETURN_ITEMS,
    ACTION_INVENTORY_SYNC_WITH_FULCRUM,
    ACTION_INVENTORY_UNARCHIVE,
    SOURCE_RESERVE_ITEMS_MODAL
  } from "@/modules/constants";
  import InventoryService from "../../inventory/InventoryService";

  const {mapState, mapActions} = createNamespacedHelpers('lots');
  const {mapActions: inventoryMapActions} = createNamespacedHelpers('inventory');
  const {mapState: salesMapState} = createNamespacedHelpers('sales');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "ReserveItemsModal",
    components: {InventoryTable, ArtisioModal},
    data() {
      return {
        loading: false,
        selectedItems: [],
        excludeHeaderActions: [
          ACTION_INVENTORY_CREATE_AND_DUPLICATE,
          ACTION_INVENTORY_GROUP_ITEMS,
          ACTION_INVENTORY_CONT_AUCTION_BATCH_LOT_UP,
          ACTION_INVENTORY_SYNC_WITH_FULCRUM,
          ACTION_INVENTORY_BATCH_DELETE,
          ACTION_INVENTORY_ARCHIVE,
          ACTION_INVENTORY_UNARCHIVE,
          ACTION_INVENTORY_RETURN_ITEMS
        ]
      }
    },
    computed: {
      ...mapState({
        modal: state => state.reserveItemsModal,
      }),
      ...salesMapState({
        sale: state => state.view.currentSale
      }),
      ...globalMapState({
        enableInventoryQuantity: state => state.enableInventoryQuantity
      }),
      disableSubmitBtn() {
        return this.selectedItems.size === 0;
      },
      assignItemsDisplayFieldFunction() {
        if (this.sale) {
          return this.$i18n.t(`Assign Items to Sale {sale_no}`, {sale_no: this.sale.sale_no});
        }
        return this.$i18n.t("Assign Items to Sale");
      },
    },
    methods: {
      ...mapActions(['hideReserveItemsModal', "getTableData"]),
      ...inventoryMapActions(['updateTableSource', 'showReserveSaleModal']),
      onHidden() {
        this.hideReserveItemsModal();
      },
      async onSubmit() {
        let itemsToReserve = []
        if (this.enableInventoryQuantity) {
          this.selectedItems.forEach(item => {
            if (item.available_quantity) {
              itemsToReserve.push(item)
            }
          });
          if (itemsToReserve.length) {
            this.hideReserveItemsModal();
            this.showReserveSaleModal({items: itemsToReserve, source: SOURCE_RESERVE_ITEMS_MODAL, sale: this.sale});
          } else {
            this.$errorDialog(this.$i18n.t('Following item(s) has already been reserved.'), this.$i18n.t('Error'));
          }
        } else {
          const requestData = [];
          this.selectedItems.forEach(item => requestData.push({sale_no: this.sale.sale_no, uuid: item.uuid}));
          let response = await InventoryService.reserveLots(requestData);

          if (response.success) {
            this.hideReserveItemsModal();
            this.$toast('success', this.$i18n.t('Items have been successfully assigned to sale {saleno}.', {saleno: this.sale.sale_no}));
            this.getTableData();
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          }
        }
      },
      onSelectedItemsChange(selectedItems) {
        this.selectedItems = selectedItems;
      }
    },
    async beforeMount() {
      await this.updateTableSource({
        source: SOURCE_RESERVE_ITEMS_MODAL,
        extraFilters: {}
      });
    }
  }
</script>

<style lang="scss" scoped>
  .reserve-items {
    /deep/ .table-sm {
      max-height: 600px;
    }
  }
</style>
